<div class="row step-header">
  <div class="col col-100">
    <h3>Starry is coming to your address soon</h3>
    <p>Enter your email for updates&mdash;and to unlock your exclusive offer.</p>
  </div>
</div>
<div class="card-layout no-border text-dark">
  <div class="row">
    <div class="col col-100">
      <label for="email">Your email address*</label>
      <div class="input-wrap">
        <input id="email" value="{{ email }}" name="email" type="email" autocorrect="off" placeholder="johnny@appleseed.com">
      </div>
      <div class="js-emailErrorContainer">
        {{#if email_error}}
          <p class="error-message error-message--email">
            {{ email_error }}
          </p>
        {{/if}}
      </div>
    </div>
    <div class="col col-100">
      <p class="email_disclaimer">
        Updates, offers, and account communications only. No spam, we promise.
      </p>
    </div>
  </div>
</div>
